<template>
	<div class="box" v-if="notification.length > 0">
		<div class="box-message">
			<div class="message">
				<span class="text-message">{{notification[0]}}</span>
			</div>
			<div class="bottom">
				<div class="create__btn" style="cursor: pointer;">
					<a class="cmn--btn" @click="removeNotification()"><span>{{$store.state.lang.text.confirm[$store.state.lang.language]}}</span></a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  data () {
    return {
      notification: this.$notification.state
    }
  },
  methods: {
    removeNotification () {
      this.$notification.removeNotification()
    }
  }
}

</script>
<style>
	.box {
		z-index: 999999;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		background-color: rgba(0,0,0,0.7);
	}
	.message {
		width: 100%;
		text-align: center;
		padding: 18px 0;
	}
	.bottom {
		display: flex;
		justify-content: center;
	}
	.box-message {
		background-color: #FFF;
		border-radius: 15px;
		width: 100%;
		padding: 0px 20px;
		max-width: 360px;
	}
	.text-message {
		text-align: center;
		color: #333;
	}

</style>



// WEBPACK FOOTER //
// src/components/NotificationPlugin/Notifications.vue